export function isPhoneSettingsEditorPath(pathname: string): boolean {
  return (
    /^\/teams\/[^/]+\/settings\/?$/.test(pathname) ||
    /^\/settings\/customers\/[^/]+\/?$/.test(pathname)
  );
}
